export default "__VITE_ASSET__BssN3A0t__"